"use strict";
require("./..\\..\\..\\bower_components\\jquery-mask-plugin\\dist\\jquery.mask.js");

module.exports = function () {

	$('[type="tel"]').mask('+7 000 000-00-00');
  
};
